import { render, staticRenderFns } from "./PromoTemplateA4MSRManual.vue?vue&type=template&id=64f8e310"
import script from "./PromoTemplateA4MSRManual.vue?vue&type=script&lang=js"
export * from "./PromoTemplateA4MSRManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports